export const VALID_TIMEZONES = [
  "America/Denver",
  "America/Chicago",
  "America/New_York",
  "America/Los_Angeles",
  "Europe/Paris",
];
